import React, {useEffect, useState} from "react";
import {useSelector,useDispatch} from "react-redux";
import '../css/Cart.css'
import {Table} from "react-bootstrap";
import firebase from "firebase";
import moment from "moment";
import {AiOutlineClose} from "react-icons/ai";
import {AddCart, SendMSG} from "./reducer";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const Cart=()=>{
    let [cartItem,setCartItem] = useState([]);
    let item = useSelector(state => state.add_cart);
    const [name,setName]=useState('');
    const [phone,setPhone]=useState('');
    const db = firebase.firestore();
    const [priceAll,setPriceAll]=useState(0);
    const [step, setStep]=useState(1);
    const dispatch = useDispatch();
    const [checked,setChecked]=useState(false);
    const [pickupTime,setPickupTime]=useState('11:00');
    const [pickupDate,setPickupDate]=useState(new Date());
    const [pickup,setPickup]=useState('');
    useEffect(()=>{
        if(item){
            setCartItem(item)
        }
    },[])

    useEffect(() => {
        if (phone.length === 10) {
            setPhone(phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'));
        }
        if (phone.length === 13) {
            setPhone(phone.replace(/-/g, '').replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3'));
        }
    }, [phone]);

    useEffect(()=>{
        setPickup(pickupDate.getMonth()+"월"+pickupDate.getDay()+"일"+pickupTime+"시")
    },[pickupTime,pickupDate])

    const handlePress = (e) => {
        const regex = /^[0-9\b -]{0,13}$/;
        if (regex.test(e.target.value)) {
            setPhone(e.target.value);
        }
    };

    const addItem =(name,phone,item,priceAll)=>{
        db.collection('reservation').add({ username : name,userphone: phone,useritem: item, usertime:moment().format('YYYY.MM.DD/HH:mm:ss'), reservationState:0,priceAll:priceAll,pickupTime:pickup})
            .then((res)=> {
                dispatch(SendMSG({phone:phone,user_name:name,user_price:priceAll}))
            }).then(()=>{
                alert("주문이 완료 되었습니다!")
                window.location.reload();
        }).catch(err=>console.log("error",err))
    }
    const PriceSetter =(arr)=>{
        let priceAdd = 0;
        arr.map((item)=>priceAdd += parseInt(item.price)*item.quan)
        setPriceAll(priceAdd)
    }

    useEffect(()=>{
        if(cartItem){
            PriceSetter(cartItem);
            dispatch(AddCart(cartItem))
        }
    },[cartItem])

    const DeleteItem = (deleteItem)=>{
        setCartItem(cartItem.filter(item=>item.id !== deleteItem.id))
    }
    const CheckHandler=(e)=>{
        setChecked(e.target.checked)
    }
    return(
        <>

            <div className={'flex__center'}>
                <div className={"location-title-background-box"}>
                    <div className={'red-dot-box'}>
                        <div className={'red-dot'}/>
                    </div>
                    <h3>장바구니</h3>
                </div>
                {
                    step === 1&&
                    <>
                        <Table className={'cart-table'}>
                            <thead className={'cart-table__thead'}>
                            <tr>
                                <th>상품명</th>
                                <th>가격</th>
                                <th>수량</th>
                                <th>삭제</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                cartItem&&
                                cartItem.map((item)=>{
                                    return(
                                        <tr key={item.id}>
                                            <td>{item.name}</td>
                                            <td>{item.price}</td>
                                            <td>{item.quan}</td>
                                            <td><AiOutlineClose size={20} cursor={'pointer'}
                                                                onClick={()=>DeleteItem(item)}
                                            /></td>
                                        </tr>
                                    )
                                })
                            }
                            </tbody>
                            <tfoot>
                            <tr>
                                <th>전체금액: {priceAll} 원</th>
                            </tr>
                            </tfoot>
                        </Table>
                        <div>
                            <span>원하시는 픽업 날짜와 시간을 선택하세요.(11:00~17:00) &nbsp;</span>
                            <div className={'flex__center cart-picker-box'}>
                                <div className={'cart-date-picker-box'}>
                                    <DatePicker
                                        selected={pickupDate} onChange={setPickupDate}
                                        dateFormat={'yyyy-MM-dd'} minDate={new Date()}
                                    />
                                </div>
                                <select onChange={e=>setPickupTime(e.target.value+pickupTime.slice(2,5))}>
                                    <option key={"11"} value={"11"}>11시</option>
                                    <option key={"12"} value={"12"}>12시</option>
                                    <option key={"13"} value={"13"}>13시</option>
                                    <option key={"14"} value={"14"}>14시</option>
                                    <option key={"15"} value={"15"}>15시</option>
                                    <option key={"16"} value={"16"}>16시</option>
                                    <option key={"17"} value={"17"}>17시</option>
                                </select>
                                <select onChange={e=>setPickupTime(pickupTime.slice(0,3)+e.target.value)}>
                                    <option key={"00"} value={"00"}>00분</option>
                                    <option key={"30"} value={"30"}>30분</option>
                                </select>
                            </div>
                        </div>
                        <div className={'item-button'} onClick={()=>{
                            if(cartItem.length>0){
                                setStep(2)
                            }else{
                                alert("장바구니에 물건을 담아주세요")
                            }
                        }}>
                            다음
                        </div>
                    </>
                }
                {
                    step===2&&
                    <>
                        <div className={'flex-center-row'}>
                            <div className={'login-input-box'}>
                                <input placeholder={"이름"} onChange={(e)=>setName(e.target.value)} value={name}/>
                                <input placeholder={"연락처"} onChange={handlePress} value={phone}/>
                            </div>
                        </div>
                        <div className={'flex__center cart-textarea-box'}>
                            <div className={'flex__center cart-textarea-box-inner'}>
                                <span>입금계좌</span>
                                <a>농협 302-1702-5043-41</a>
                                <br/>
                            </div>
                            <div className={'flex__center cart-textarea-box-inner'}>
                                <span>이용약관</span>
                                <textarea
                                    readOnly={true}
                                    placeholder="1. 수집하는 개인정보의 항목 및 수집방법
                                            회원가입, 비회원 구매, 상담, 불량이용의 방지 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.
                                            - 필수항목 : 성명, 아이디, 비밀번호, 연락처(휴대폰), 결제기록
                                            - 선택항목 : 개인맞춤 서비스를 제공하기 위하여 회사가 필요로 하는 정보
                                            - 수집방법 : 홈페이지

                                            2. 개인정보의 수집 및 이용목적
                                            수집한 개인정보는 다음의 목적을 위해 활용합니다.
                                            가. 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산, 콘텐츠 제공, 구매 및 요금 결제, 물품배송 또는 청구지 등 발송, 금융거 래 본인 인증 및 금융서비스
                                            나. 성명 , 아이디, 비밀번호: 회원제 서비스 이용에 따른 본인 확인 절차에 이용
                                            - 개인 식별, 불량회원의 부정 이용 방지와 비인가 사용 방지, 가입 의사 확인, 연령확인, 불만처리 등 고객 민원처리, 고지사항 전달
                                            다. 서비스 및 이벤트 제공
                                            - 전화번호 : 고지사항 전달, 불만처리, 부가서비스 등을 위한 원활한 의사소통 경로의 확보, 새로운 서비스 및 신상품이나 이벤트 정보 등의 안내
                                            - 이름, 핸드폰번호 : 이벤트진행을 위해 이름, 핸드폰번호가 저장되어 이용됨.
                                            라. 결제처리
                                            - 은행계좌정보, 신용카드정보 : 서비스 및 부가 서비스 이용에 대한 요금 결제
                                            - 전화번호 : 청구서, 물품배송시 정확한 배송지의 확보
                                            - 기타 선택항목 : 개인맞춤 서비스를 제공하기 위한 자료
                                            마. 부정이용 방지
                                            - IP Address : 불량회원의 부정 이용 방지와 비인가 사용 방지

                                            3. 개인정보의 보유 및 이용기간
                                            회원탈퇴 또는 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지제 없이 파기합니다. 다만, 서비스의 부정/불량이용자의 재가입 방지를 위해 해지 후 3개월간 보유할 수 있으며 전자상거래에서의 소비자보호에 관한법률 등 타 법률에 의해 보존의무가 있는경우에는 볍령이 지정한 일정기간 보존합니다."
                                >
                            </textarea>
                            </div>
                            <label>위의 이용 약관에 동의 합니다
                                <input type={"checkbox"} checked={checked} onChange={(e) => CheckHandler(e)}/>
                            </label>
                        </div>
                        <div className={'item-button'} onClick={()=>{
                            if(name && phone &&checked){
                                addItem(name,phone,cartItem,priceAll);
                                //window.location.reload();
                            }else{
                                alert('이름과 연락처를 입력하시고 약관에 동의 해주세요')
                            }
                        }}>
                            주문하기
                        </div>
                    </>
                }
            </div>
        </>
    );
}

export default Cart
